/* eslint no-param-reassign: ["error", { "props": false }]*/
/* eslint no-restricted-syntax: 0 */
/* eslint consistent-this: 0 */

import updateText from '../utils/update-text';

import setPosition from './set-tr-position';

export default function(data, firstRun) {
  const root = this;

  // grab tbody
  const tbody = root.querySelector('tbody');

  // grab trs as an array
  const trs = Array.prototype.slice.call(tbody.querySelectorAll('tr'));

  // run through each tr and add a current position
  // also add a starting position, but only on the first run
  // we will use the starting poisition to calculate the movement arrows
  trs.forEach((tr, index) => {
    tr.currentPosition = index + 1;
    if (firstRun) {
      tr.startingPosition = index + 1;
    }
  });

  // run through the data and find matching trs
  data.table.rows.forEach((row) => {
    // create a goals entry
    row.goals = [row.f, row.a].join(':');

    // get id of team in this row
    const rowId = (row.team && row.team.id) || row.id;

    // get matching tr in dom
    const tr = root.querySelector(`[data-row-id="${rowId}"]`);

    // if tr exists, update contents
    if (tr) {
      for (const key in row) {
        if ({}.hasOwnProperty.call(row, key)) {
          updateText(tr.querySelector(`[data-live-key='${key}']`), row[key]);
        }
      }

      // calculate and update position
      if (row.pos) {
        setPosition(tr, Number(row.pos));
      }
    }
  });

  // reorder cells in dom after short delay to allow animation to play out
  setTimeout(() => {
    trs.sort((a, b) => a.currentPosition - b.currentPosition);

    trs.forEach((tr) => {
      // remove transform and data animating attribute
      tr.style.cssText = null;
      tr.removeAttribute('data-animating');

      // reappend trs in correct order
      tbody.appendChild(tr);
    });
  }, 500);
}
